import { render, staticRenderFns } from "./ProjectGallery.vue?vue&type=template&id=66cf0a86&scoped=true&"
import script from "./ProjectGallery.vue?vue&type=script&lang=js&"
export * from "./ProjectGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGallery.vue?vue&type=style&index=0&id=66cf0a86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf0a86",
  null
  
)

export default component.exports